export const mail = {
    '站内信': 'mensagem da estação',
    '返回': 'retornar',
    '有未读信息': 'Existem {amount} mensagens não lidas',
    '全部标记为已读': 'marcar tudo como lido',
    '隐藏已读消息': 'ocultar mensagens lidas',
    '展开': 'expandir',
  };


// WEBPACK FOOTER //
// ./src/i18n/lang/mail/pt_BR.js